import { unescape } from "lodash-es";

const formatName = (name: string): string => unescape(name);

export { formatName };
